export default __webpack_public_path__ + "img/Eyestalk.9476f3f8.png";